import { ICurator } from "./curator";
import { IPlaylistRecord } from "./playlist";
import { emptyInitialStateShopRecord, IShopRecord } from "./shopRecord";

export enum ShopCuratorBinType {
  BIN1 = "bin1",
  BIN2 = "bin2",
}

export type IShopCurator = {
  id: number | null;
  documentId: string | null;
  curator: ICurator | null;
  description: string | null;
  playlist: IPlaylistRecord | null;
  shopRecords: IShopRecord[];
  active: boolean;
  vinylListEnabled: boolean;
  bin: ShopCuratorBinType;
};

export const emptyInitialStateShopCurator: IShopCurator = {
  id: null,
  documentId: null,
  curator: null,
  description: null,
  playlist: null,
  active: false,
  bin: ShopCuratorBinType.BIN1,
  shopRecords: Array(5)
    .fill(null)
    .map(() => ({ ...emptyInitialStateShopRecord })),
  vinylListEnabled: false,
};
